// import React, { createContext, useContext, useState, useCallback } from "react";

// const RangeFilterContext = createContext();

// export function RangeFilterProvider({ children }) {
//   const [filters, setFilters] = useState({
//     area: { min: 0, max: Infinity },  
//     price: { min: 0, max: Infinity } 
//   });

//   const updateRangeFilters = useCallback((newFilters) => {
//     setFilters((prev) => {
//       const updated = { ...prev, ...newFilters };
//       return updated;
//     });
//   }, []);

//   return (
//     <RangeFilterContext.Provider value={{ filters, updateRangeFilters }}>
//       {children}
//     </RangeFilterContext.Provider>
//   );
// }

// export function useRangeFilter() {
//   const context = useContext(RangeFilterContext);
//   if (!context) {
//     throw new Error("useRangeFilter must be used within RangeFilterProvider");
//   }
//   return context;
// }
















import React, { createContext, useContext, useState, useCallback } from "react";

const RangeFilterContext = createContext();

export function RangeFilterProvider({ children, lang }) {
  const [filters, setFilters] = useState({
    area: { min: 0, max: Infinity },
    price: { min: 0, max: Infinity },
  });

  // ← أضفنا state للمقابض هنا
  const [areaHandles, setAreaHandles] = useState({
    left: 0,
    right: Infinity,
  });

  const [priceHandles, setPriceHandles] = useState({
    left: 0,
    right: Infinity,
  });

  const updateRangeFilters = useCallback((newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  }, []);

  // دالة لتحديث المقابض (يمكن استدعاؤها من Range)
  const updateHandles = useCallback((type, newHandles) => {
    if (type === "area") {
      setAreaHandles(newHandles);
    } else if (type === "price") {
      setPriceHandles(newHandles);
    }
  }, []);

  return (
    <RangeFilterContext.Provider
      value={{
        filters,
        updateRangeFilters,
        areaHandles,
        priceHandles,
        updateHandles,
        lang
      }}
    >
      {children}
    </RangeFilterContext.Provider>
  );
}

export function useRangeFilter() {
  const context = useContext(RangeFilterContext);
  if (!context) {
    throw new Error("useRangeFilter must be used within RangeFilterProvider");
  }
  return context;
}